import React, { useEffect, useState, Suspense, lazy } from 'react';
import { Box, Container, Heading, Text, VStack, SimpleGrid, Divider, Image } from '@chakra-ui/react';
import { ServiceSection } from '../components/ServiceSection';
import { CTAButton } from '../components/CTAButton';
import { StickyTopBar } from '../components/StickyTopBar';
import { FloatingWhatsAppButton } from '../components/FloatingWhatsAppButton';
const LiveActivityCounter = lazy(() => import('../components/LiveActivityCounter').then(m => ({
  default: m.LiveActivityCounter
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
export function LandingPage() {
  const whatsappUrl = 'https://wa.me/+16058247498';
  const phoneUrl = 'tel:+16055406973';
  const [videoFailed, setVideoFailed] = useState(false);
  useEffect(() => {
    // Tawk.to Script - defer by 5 seconds to prioritize page content
    if (typeof window === 'undefined') return;
    const tawkTimeout = setTimeout(() => {
      var s1 = document.createElement('script');
      var s0 = document.getElementsByTagName('script')[0];
      if (!s0 || !s0.parentNode) {
        document.head.appendChild(s1);
      } else {
        s0.parentNode.insertBefore(s1, s0);
      }
      s1.async = true;
      s1.src = 'https://embed.tawk.to/6839ef8f9796bf190d6448da/1ish4vion';
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');
    }, 5000);
    return () => clearTimeout(tawkTimeout);
  }, []);
  return <Box bg="#0a0a0a" minH="100vh" w="full" data-id="element-56" data-mp="3n6ojqh0ezmz7">
      {/* Sticky Top Bar */}
      <StickyTopBar whatsappUrl={whatsappUrl} data-id="element-57" data-mp="3rb63ig6ry09z" />

      {/* Floating WhatsApp Button */}
      <FloatingWhatsAppButton whatsappUrl={whatsappUrl} data-id="element-58" data-mp="41y1pqa2m3o" />

      {/* Hero Section */}
      <Box position="relative" pt={{
      base: 12,
      md: 20
    }} pb={{
      base: 12,
      md: 16
    }} overflow="hidden" data-id="element-59" data-mp="1wwll6a5xegtr">
        <Box position="absolute" top={0} left={0} right={0} bottom={0} zIndex={0} data-id="element-60" data-mp="355khv0wn0u45">
          <Image src="https://cdn.magicpatterns.com/uploads/vcEBSogWdf7QtPCTn7govW/freepik__the-style-is-candid-image-photography-with-natural__67051.png" alt="Energía mística" w="full" h="full" objectFit="cover" filter="brightness(0.3)" data-id="element-61" data-mp="308u4ilc7wcmf" />
          <Box position="absolute" top={0} left={0} right={0} bottom={0} bgGradient="linear(to-b, rgba(220, 38, 38, 0.3), rgba(10, 10, 10, 0.95))" data-id="element-62" data-mp="3j5v8q3xy68pb" />
        </Box>

        <Container maxW="container.xl" position="relative" zIndex={1} data-id="element-63" data-mp="3swpwjcqudgcv">
          <VStack spacing={4} textAlign="center" data-id="element-64" data-mp="apikt2bldr8h">
            <Heading as="h1" fontSize={{
            base: '3xl',
            md: '5xl',
            lg: '6xl'
          }} fontWeight="black" textTransform="uppercase" letterSpacing="tighter" color="white" lineHeight="shorter" maxW="900px" textShadow="0 0 20px rgba(255, 255, 255, 0.5), 0 0 40px rgba(220, 38, 38, 0.6)" data-id="element-65" data-mp="aqbjrh4b7cg2">
              ¿TE ESTÁN QUITANDO LO QUE ES TUYO?
            </Heading>

            <Text fontSize={{
            base: 'lg',
            md: 'xl',
            lg: '2xl'
          }} color="gray.300" maxW="800px" lineHeight="short" fontStyle="italic" data-id="element-66" data-mp="6lptj54kniw5">
              Si se está alejando… Si ya no te busca como antes… Si duerme
              diferente… Si hay alguien más ocupando tu lugar…
            </Text>

            <Text fontSize={{
            base: 'xl',
            md: '2xl'
          }} color="brand.400" fontWeight="bold" mt={2} data-id="element-67" data-mp="3jtb2y15j7c6i">
              No es coincidencia.
            </Text>

            <Text fontSize={{
            base: 'lg',
            md: 'xl'
          }} color="gray.200" fontWeight="semibold" data-id="element-68" data-mp="3brtm0dfvqgir">
              Es energía moviéndose en tu contra.
            </Text>

            {!videoFailed && <>
                <Box w="full" maxW="800px" mt={4} borderRadius="lg" overflow="hidden" boxShadow="0 0 30px rgba(220, 38, 38, 0.3)" data-id="element-69" data-mp="2y1gfmfimz9vj">
                  <video controls playsInline preload="metadata" onError={() => setVideoFailed(true)} style={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }} src="https://cdn.magicpatterns.com/uploads/8MtiGQzPf5Uwfq8gXqGonv/pikaso-untitled-project-2026-02-24%20(1).mp4" data-id="element-70" data-mp="2j3fr46k380bf">
                    Tu navegador no soporta el elemento de video.
                  </video>
                </Box>

                <Text fontSize="xs" color="gray.400" mt={0} fontStyle="italic" maxW="800px" data-id="element-71" data-mp="13kzu647fabog">
                  Martha Molina: Ella sabe y reconoce nuestros conocimientos
                  reales
                </Text>
              </>}

            <Box borderTop="2px solid" borderColor="fire.500" pt={4} mt={4} w="full" maxW="600px" data-id="element-72" data-mp="fwytfhghjzjl">
              <Heading as="h2" fontSize={{
              base: '2xl',
              md: '3xl'
            }} color="fire.400" textTransform="uppercase" mb={4} fontWeight="black" textShadow="0 0 15px rgba(245, 158, 11, 0.8), 0 0 30px rgba(220, 38, 38, 0.5)" data-id="element-73" data-mp="1r9ssg7biovm8">
                ACTÚA ANTES DE QUE SEA TARDE
              </Heading>

              <VStack spacing={3} data-id="element-74" data-mp="1bl4hfnww9n2u">
                <CTAButton href={whatsappUrl} size="xl" w="full" maxW="500px" data-id="element-75" data-mp="1bi07e9wqzx49">
                  ESCRÍBENOS AHORA POR WHATSAPP
                </CTAButton>

                <CTAButton href={phoneUrl} size="xl" w="full" maxW="500px" bg="blue.600" bgGradient="linear(to-r, blue.600, blue.700)" _hover={{
                bgGradient: 'linear(to-r, blue.500, blue.600)',
                transform: 'scale(1.02)',
                filter: 'brightness(1.2)'
              }} data-id="element-76" data-mp="iwgulnwhypn6">
                  LLAMAR AHORA
                </CTAButton>
              </VStack>

              <Text fontSize="sm" color="gray.400" mt={2} data-id="element-77" data-mp="2bqgex10sqje1">
                Atención privada e inmediata
              </Text>
            </Box>
          </VStack>
        </Container>
      </Box>

      {/* Positioning Section */}
      <Box position="relative" py={{
      base: 12,
      md: 16
    }} mt={12} overflow="hidden" data-id="element-78" data-mp="26snaacf55xfv">
        <Box position="absolute" top={0} left={0} right={0} bottom={0} zIndex={0} data-id="element-79" data-mp="2ujka4qtnx4ar">
          <Image src="https://images.unsplash.com/photo-1604881991720-f91add269bed?w=800&q=70" alt="Tradición ancestral" w="full" h="full" objectFit="cover" filter="brightness(0.25)" loading="lazy" data-id="element-80" data-mp="2liujs2n6864f" />
          <Box position="absolute" top={0} left={0} right={0} bottom={0} bg="rgba(26, 26, 26, 0.7)" data-id="element-81" data-mp="1e50xcdk0xggc" />
        </Box>

        <Container maxW="container.lg" position="relative" zIndex={1} data-id="element-82" data-mp="20shkwkor8krs">
          <VStack spacing={6} textAlign="center" data-id="element-83" data-mp="20vc5qdbok7lq">
            <Heading as="h2" fontSize={{
            base: '2xl',
            md: '4xl'
          }} color="brand.400" textTransform="uppercase" fontWeight="black" letterSpacing="wide" textShadow="0 0 20px rgba(220, 38, 38, 0.8), 0 0 40px rgba(220, 38, 38, 0.4)" data-id="element-84" data-mp="1wsflki6hs3fo">
              AQUÍ NO DAMOS CONSEJOS. TRABAJAMOS ENERGÍA REAL.
            </Heading>

            <Text fontSize={{
            base: 'lg',
            md: 'xl'
          }} color="gray.300" maxW="800px" lineHeight="tall" data-id="element-85" data-mp="2arp0leiyori2">
              No somos motivadores. No hacemos "ritualitos" genéricos.
            </Text>

            <Text fontSize={{
            base: 'lg',
            md: 'xl'
          }} color="white" maxW="800px" lineHeight="tall" fontWeight="semibold" data-id="element-86" data-mp="3arshsp1cimr8">
              Somos practicantes de tradición ancestral con más de 40 años de
              experiencia.
            </Text>

            <Text fontSize={{
            base: 'md',
            md: 'lg'
          }} color="gray.400" maxW="700px" mt={4} data-id="element-87" data-mp="3tq4ps7gitql8">
              Cada caso se analiza. Cada ritual se prepara exclusivamente para
              una persona. Cada proceso se trabaja con intención firme.
            </Text>

            <Box bg="rgba(220, 38, 38, 0.1)" borderWidth="2px" borderColor="brand.500" borderRadius="md" p={6} mt={6} data-id="element-88" data-mp="cb6dgu20izvp">
              <Text fontSize={{
              base: 'lg',
              md: 'xl'
            }} color="fire.400" fontWeight="bold" data-id="element-89" data-mp="1g7gmssqqtm0u">
                Si aceptamos tu caso, es porque vemos movimiento posible.
              </Text>
            </Box>

            <CTAButton href={whatsappUrl} mt={8} data-id="element-90" data-mp="1uwcs4i1f0kxr">
              CONSULTA TU CASO AHORA
            </CTAButton>
          </VStack>
        </Container>
      </Box>

      {/* Live Activity Counter - Floating Notifications */}
      <Suspense fallback={null} data-id="element-91" data-mp="23vhp3jxbw67t">
        <LiveActivityCounter data-id="element-92" data-mp="23ym296srucam" />
      </Suspense>

      {/* Services Section */}
      <Container maxW="container.xl" py={{
      base: 12,
      md: 20
    }} data-id="element-93" data-mp="28wnkjpidi7l1">
        <SimpleGrid columns={{
        base: 1,
        lg: 3
      }} spacing={8} data-id="element-94" data-mp="2dsw3ldzoykxh">
          <ServiceSection imageUrl="https://cdn.magicpatterns.com/uploads/wmoq8U6ujmtp9hKFZSLm6E/freepik__create-a-logo-featuring-two-real-people-an-african__48719.jpg" title="DOMINACIÓN ATRACCIÓN REGRESIÓN ENERGÉTICA" description="Cuando dos personas se desconectan, el vínculo no desaparece… se debilita. Y lo que se debilita… puede reactivarse." features={['Enlace emocional', 'Intensificación de deseo', 'Recuperación de atención', 'Desbloqueo de interferencias', 'Reordenamiento energético del vínculo']} ctaText="INICIA TU PROCESO HOY" ctaHref={whatsappUrl} variant="highlighted" data-id="element-95" data-mp="jgo2tk0ov9ts" />

          <ServiceSection imageUrl="https://cdn.magicpatterns.com/uploads/dk9mQGgEQPHabcM6NvRidH/Captura_de_pantalla_2025-02-26_103828_(1).png" title="CORTE Y ALEJAMIENTO DE TERCERAS PERSONAS" description="Cuando alguien interfiere en tu relación… Cuando sientes que te están desplazando… Cuando una presencia rompe tu estabilidad… Se puede trabajar el corte energético." features={['Se debilitan conexiones', 'Se enfrían vínculos', 'Se separan caminos', 'Con protección espiritual y guía experta']} ctaText="RECUPERA TU LUGAR" ctaHref={whatsappUrl} data-id="element-96" data-mp="36rhs28aizliw" />

          <ServiceSection imageUrl="https://cdn.magicpatterns.com/uploads/fZSvWUfPPMxEtiAyE4NKRd/Captura_de_pantalla_2025-05-30_225505_(1).png" title="APERTURA DE CAMINOS Y ABUNDANCIA" description="Si el dinero no fluye… Si todo se estanca… Si sientes bloqueo constante… No siempre es falta de esfuerzo. A veces es carga energética." features={['Rituales de apertura de caminos', 'Activación de prosperidad', 'Movimiento de energías estancadas', 'Atracción de estabilidad']} ctaText="ACTIVA TU PROSPERIDAD" ctaHref={whatsappUrl} data-id="element-97" data-mp="1nsjw3osogptk" />
        </SimpleGrid>
      </Container>

      {/* Warning Section */}
      <Box position="relative" borderTop="2px solid" borderBottom="2px solid" borderColor="brand.600" py={{
      base: 12,
      md: 16
    }} overflow="hidden" data-id="element-98" data-mp="6i88ipfleluj">
        <Box position="absolute" top={0} left={0} right={0} bottom={0} zIndex={0} data-id="element-99" data-mp="ge1lub14yjdd">
          <Image src="https://images.unsplash.com/photo-1516339901601-2e1b62dc0c45?w=800&q=70" alt="Exclusividad" w="full" h="full" objectFit="cover" filter="brightness(0.2)" loading="lazy" data-id="element-100" data-mp="pgsyge5qzl6l" />
          <Box position="absolute" top={0} left={0} right={0} bottom={0} bg="rgba(153, 27, 27, 0.4)" data-id="element-101" data-mp="1d5c38jpl9ftx" />
        </Box>

        <Container maxW="container.md" position="relative" zIndex={1} data-id="element-102" data-mp="32n0qn4xwu0yi">
          <VStack spacing={6} textAlign="center" data-id="element-103" data-mp="32kwlkjo9yvwn">
            <Heading as="h2" fontSize={{
            base: '2xl',
            md: '4xl'
          }} color="brand.400" textTransform="uppercase" fontWeight="black" textShadow="0 0 20px rgba(220, 38, 38, 0.8), 0 0 40px rgba(220, 38, 38, 0.4)" data-id="element-104" data-mp="37ksg7sb31azj">
              ESTO NO ES PARA TODOS
            </Heading>

            <Text fontSize={{
            base: 'lg',
            md: 'xl'
          }} color="gray.300" lineHeight="tall" data-id="element-105" data-mp="2onr8w0u22ysf">
              Si dudas de todo. Si solo tienes curiosidad. Si no estás dispuesto
              a seguir indicaciones.
            </Text>

            <Text fontSize={{
            base: 'xl',
            md: '2xl'
          }} color="white" fontWeight="bold" lineHeight="tall" data-id="element-106" data-mp="8xwo208fcip0">
              Este no es tu lugar.
            </Text>

            <Text fontSize={{
            base: 'lg',
            md: 'xl'
          }} color="fire.400" fontWeight="semibold" data-id="element-107" data-mp="1tee6eu5zmiqm">
              Trabajamos con personas decididas.
            </Text>

            <Text fontSize={{
            base: 'lg',
            md: 'xl'
          }} color="gray.200" fontWeight="semibold" data-id="element-108" data-mp="1ep89jcumh4lw">
              Personas que no quieren seguir perdiendo.
            </Text>
          </VStack>
        </Container>
      </Box>

      {/* Testimonials Section */}
      <Suspense fallback={null} data-id="element-109" data-mp="10r9ue58h945c">
        <TestimonialsSection data-id="element-110" data-mp="302ul4stne2fu" />
      </Suspense>

      {/* Final Urgency Section */}
      <Box position="relative" py={{
      base: 12,
      md: 20
    }} overflow="hidden" data-id="element-111" data-mp="2v384e9em242a">
        <Box position="absolute" top={0} left={0} right={0} bottom={0} zIndex={0} data-id="element-112" data-mp="3e6s3q7v662l4">
          <Image src="https://images.unsplash.com/photo-1501139083538-0139583c060f?w=800&q=70" alt="El tiempo corre" w="full" h="full" objectFit="cover" filter="brightness(0.25)" loading="lazy" data-id="element-113" data-mp="357533oa9l0t4" />
          <Box position="absolute" top={0} left={0} right={0} bottom={0} bgGradient="linear(to-b, transparent, rgba(220, 38, 38, 0.2))" data-id="element-114" data-mp="1oljtb9kd5ag" />
        </Box>

        <Container maxW="container.lg" position="relative" zIndex={1} data-id="element-115" data-mp="3sw7s5h789vxn">
          <VStack spacing={8} textAlign="center" data-id="element-116" data-mp="3syk6zlhovq6h">
            <Heading as="h2" fontSize={{
            base: '3xl',
            md: '5xl'
          }} color="white" textTransform="uppercase" fontWeight="black" letterSpacing="tight" textShadow="0 0 20px rgba(255, 255, 255, 0.5), 0 0 40px rgba(220, 38, 38, 0.6)" data-id="element-117" data-mp="2chproxeot5wo">
              NO LLEGASTE AQUÍ POR ACCIDENTE
            </Heading>

            <Text fontSize={{
            base: 'lg',
            md: 'xl'
          }} color="gray.300" maxW="700px" lineHeight="tall" data-id="element-118" data-mp="2dzn0dhohaq2z">
              Si estás leyendo esto…
            </Text>

            <Text fontSize={{
            base: 'xl',
            md: '2xl'
          }} color="fire.400" fontWeight="bold" maxW="700px" data-id="element-119" data-mp="1m6dyxl25ncto">
              Es porque algo dentro de ti sabe que el tiempo corre.
            </Text>

            <Box my={8} data-id="element-120" data-mp="17h803y78bomb">
              <Text fontSize={{
              base: 'md',
              md: 'lg'
            }} color="gray.400" mb={2} data-id="element-121" data-mp="12l14ozcglvim">
                Cada día que pasa sin actuar…
              </Text>
              <Text fontSize={{
              base: 'lg',
              md: 'xl'
            }} color="gray.300" data-id="element-122" data-mp="m2c7w83vlkzw">
                La distancia crece. El frío aumenta. La energía cambia.
              </Text>
            </Box>

            <Divider borderColor="brand.600" maxW="400px" data-id="element-123" data-mp="10x9zuzv448gg" />

            <Box mt={8} data-id="element-124" data-mp="14yc2zrs5h4np">
              <Text fontSize={{
              base: 'xl',
              md: '2xl'
            }} color="white" fontWeight="bold" mb={6} data-id="element-125" data-mp="14xkhj9s9onb5">
                La pregunta es simple:
              </Text>
              <Text fontSize={{
              base: 'lg',
              md: 'xl'
            }} color="gray.300" lineHeight="tall" data-id="element-126" data-mp="1jpb7aqlyd71h">
                ¿Vas a mirar cómo lo pierdes… o vas a intervenir?
              </Text>
            </Box>

            <Box bg="rgba(0, 0, 0, 0.6)" borderWidth="2px" borderColor="fire.500" borderRadius="lg" p={{
            base: 8,
            md: 12
          }} mt={12} w="full" maxW="700px" data-id="element-127" data-mp="344hf91vkf130">
              <Heading as="h3" fontSize={{
              base: '2xl',
              md: '3xl'
            }} color="fire.400" textTransform="uppercase" mb={8} fontWeight="black" textShadow="0 0 15px rgba(245, 158, 11, 0.8), 0 0 30px rgba(220, 38, 38, 0.5)" data-id="element-128" data-mp="3rxhgewgovnhx">
                ÚLTIMA OPORTUNIDAD PARA ACTUAR
              </Heading>

              <VStack spacing={4} data-id="element-129" data-mp="9ogxn5mwzc50">
                <CTAButton href={whatsappUrl} w="full" size="lg" fontSize={{
                base: 'sm',
                md: 'md'
              }} py={6} whiteSpace="normal" height="auto" lineHeight="1.3" data-id="element-130" data-mp="20aujlwcbwzjy">
                  WHATSAPP DIRECTO
                  <br data-id="element-131" data-mp="2j13t7rag3tlo" />
                  RESPUESTA INMEDIATA
                </CTAButton>

                <CTAButton href={phoneUrl} w="full" size="lg" fontSize={{
                base: 'sm',
                md: 'md'
              }} py={6} bg="blue.600" bgGradient="linear(to-r, blue.600, blue.700)" borderColor="blue.500" color="white" _hover={{
                bgGradient: 'linear(to-r, blue.500, blue.600)',
                transform: 'scale(1.02)',
                filter: 'brightness(1.2)'
              }} className="" data-id="element-132" data-mp="2ezqstwq4gim5">
                  LLAMADA PRIVADA
                </CTAButton>

                <CTAButton href={whatsappUrl} w="full" size="lg" fontSize={{
                base: 'sm',
                md: 'md'
              }} py={6} whiteSpace="normal" height="auto" lineHeight="1.3" data-id="element-133" data-mp="3f75ls9dy409g">
                  QUIERO EMPEZAR MI
                  <br data-id="element-134" data-mp="1tu3co40l9tw" />
                  PROCESO AHORA
                </CTAButton>
              </VStack>
            </Box>
          </VStack>
        </Container>
      </Box>

      {/* Footer */}
      <Box bg="rgba(10, 10, 10, 0.95)" py={8} borderTop="1px solid" borderColor="gray.800" data-id="element-135" data-mp="avbia35or5h0">
        <Container maxW="container.xl" data-id="element-136" data-mp="fqh4z46wwo65">
          <Text textAlign="center" color="gray.500" fontSize="sm" data-id="element-137" data-mp="2bwzuvgzketic">
            Tradición ancestral • Más de 40 años de experiencia • Atención
            personalizada
          </Text>
        </Container>
      </Box>
    </Box>;
}